var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer", attrs: { id: "footer" } }, [
      _c("p", [
        _vm._v("Copyright © 2023 All rights reserved by nunaps co.,ltd."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }